var __defProp = Object.defineProperty;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __publicField = (obj, key, value) => __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
const HEADER_THRESHOLD = 200;
class ScrollDispatcher {
  constructor() {
    __publicField(this, "scrollY", 0);
    __publicField(this, "prevScrollY", 0);
    __publicField(this, "dir", null);
    __publicField(this, "prevDir", null);
    __publicField(this, "passed", false);
    __publicField(this, "_lenis", null);
    __publicField(this, "_lastTime", 0);
    __publicField(this, "_THROTTLE_MS", 100);
    // ~10fps — sufficient for direction & threshold detection
    __publicField(this, "_subs", { update: /* @__PURE__ */ new Set(), "direction-change": /* @__PURE__ */ new Set(), "passed-header": /* @__PURE__ */ new Set() });
    __publicField(this, "_onNative", () => {
      const now = performance.now();
      if (now - this._lastTime < this._THROTTLE_MS) {
        if (!this._trailingRaf) {
          this._trailingRaf = requestAnimationFrame(() => {
            this._trailingRaf = 0;
            this._lastTime = performance.now();
            this._onScroll();
          });
        }
        return;
      }
      if (this._trailingRaf) {
        cancelAnimationFrame(this._trailingRaf);
        this._trailingRaf = 0;
      }
      this._lastTime = now;
      this._onScroll();
    });
    __publicField(this, "_onScroll", (e) => {
      const y = (e == null ? void 0 : e.scroll) ?? this._y();
      const dy = y - this.prevScrollY;
      if (Math.abs(dy) < 1) return;
      const dir = dy > 0 ? "down" : "up";
      const dirChanged = dir !== this.prevDir && this.prevDir !== null;
      const wasPassed = this.passed;
      const passed = y > HEADER_THRESHOLD;
      this.prevScrollY = this.scrollY;
      this.prevDir = this.dir;
      this.scrollY = y;
      this.dir = dir;
      this.passed = passed;
      const d = { scrollY: y, direction: dir, isPassedHeader: passed, passed };
      this._fire("update", d);
      if (dirChanged) this._fire("direction-change", d);
      if (passed !== wasPassed) this._fire("passed-header", d);
    });
  }
  init() {
    this._bound = false;
    window.dispatchEvent(new CustomEvent("scroll-dispatcher:ready", { detail: { dispatcher: this } }));
    return this;
  }
  /** Bind scroll listener lazily — only when something actually subscribes. */
  _ensureBound() {
    if (this._bound) return;
    this._bound = true;
    this.scrollY = this.prevScrollY = this._y();
    this.passed = this.scrollY > HEADER_THRESHOLD;
    this._bind();
  }
  setLenis(lenis) {
    if (this._lenis) this._lenis.off("scroll", this._onScroll);
    this._lenis = lenis;
    this._bind();
  }
  on(type, cb) {
    var _a;
    this._ensureBound();
    (_a = this._subs[type]) == null ? void 0 : _a.add(cb);
    return () => {
      var _a2;
      return (_a2 = this._subs[type]) == null ? void 0 : _a2.delete(cb);
    };
  }
  getState() {
    return { scrollY: this.scrollY, direction: this.dir, isPassedHeader: this.passed };
  }
  // --- Internal ---
  _y() {
    var _a;
    return ((_a = this._lenis) == null ? void 0 : _a.scroll) ?? window.scrollY ?? 0;
  }
  _bind() {
    if (this._lenis) {
      this._lenis.on("scroll", this._onScroll);
    } else {
      window.addEventListener("scroll", this._onNative, { passive: true });
    }
  }
  _fire(type, d) {
    var _a;
    (_a = this._subs[type]) == null ? void 0 : _a.forEach((cb) => cb(d));
  }
  destroy() {
    if (this._lenis) this._lenis.off("scroll", this._onScroll);
    window.removeEventListener("scroll", this._onNative);
    if (this._trailingRaf) cancelAnimationFrame(this._trailingRaf);
    Object.values(this._subs).forEach((s) => s.clear());
  }
}
const scrollDispatcher = new ScrollDispatcher();
const onScrollDirectionChange = (cb) => scrollDispatcher.on("direction-change", cb);
const onScrollUpdate = (cb) => scrollDispatcher.on("update", cb);
const onPassedHeader = (cb) => scrollDispatcher.on("passed-header", cb);
const getScrollState = () => scrollDispatcher.getState();
export {
  onScrollUpdate as a,
  onPassedHeader as b,
  getScrollState as g,
  onScrollDirectionChange as o,
  scrollDispatcher as s
};
